import styled from "styled-components";

export const SectionalTitleContainer = styled.div`
    display: flex;
    align-items: center;
    & .MuiChip-root {
        margin-left: 16px;
    }
`;
